<template>
    <div
        class="modal fade"
        id="design-imprint-too-small-modal"
        tabindex="-1"
        aria-hidden="true"
        data-keyboard="true"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered mm-dialog">
            <div class="modal-content mm-content">
                <button
                    type="button"
                    class="mm-close"
                    data-dismiss="modal"
                    @click="$emit('close')"
                    aria-label="Close"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 1l12 12M13 1L1 13" stroke="#888" stroke-width="2" stroke-linecap="round" />
                    </svg>
                </button>

                <div class="mm-icon-wrap">
                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                        <circle cx="22" cy="22" r="22" fill="#FFF3CD" />
                        <path d="M22 13v12M22 28v2" stroke="#E6A817" stroke-width="2.5" stroke-linecap="round" />
                    </svg>
                </div>

                <h5 class="mm-title">Design Can't Be Applied</h5>

                <p class="mm-subtitle">
                    <span class="mm-design-name">{{ designName }}</span>
                    was created for a larger print area than this product supports.
                </p>

                <p class="mm-hint">
                    Please select a design that fits within this product's imprint area, or create a new design for this product.
                </p>

                <button
                    type="button"
                    class="mm-btn-ok"
                    data-dismiss="modal"
                    @click="$emit('close')"
                >
                    Got it
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DesignImprintTooSmallModal",
    props: {
        designName: {
            type: String,
            default: "This design"
        }
    }
};
</script>

<style scoped>
.mm-dialog {
    max-width: 460px;
    width: 100%;
}

.mm-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.14);
    padding: 36px 32px 28px;
    text-align: center;
    position: relative;
}

.mm-close {
    position: absolute;
    top: 14px;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    line-height: 1;
    opacity: 0.6;
    transition: opacity 0.15s;
}
.mm-close:hover {
    opacity: 1;
}

.mm-icon-wrap {
    margin-bottom: 16px;
}

.mm-title {
    font-size: 18px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 10px;
}

.mm-subtitle {
    font-size: 14px;
    color: #555;
    margin-bottom: 22px;
    line-height: 1.6;
}

.mm-design-name {
    font-weight: 600;
    color: #1a1a1a;
}

.mm-hint {
    font-size: 12px;
    color: #888;
    margin-bottom: 22px;
    line-height: 1.5;
}

.mm-btn-ok {
    display: inline-block;
    background: #e6730a;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 40px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
}
.mm-btn-ok:hover {
    background: #c95f05;
}
</style>

